export default "__VITE_ASSET__lXmPaclI__"